import {
  Box,
  SpaceBetween,
} from '@cloudscape-design/components';
import {
  colorBackgroundContainerContent,
  colorBorderDividerDefault,
  colorBorderItemSelected,
} from '@cloudscape-design/design-tokens';
import {
  Handle,
  Position,
} from '@xyflow/react';
import PPartRefBadge from 'components/Projects/pPartRefBadge';
import PPartStatusBadge from 'components/Projects/pPartStatusBadge';
import PropTypes from 'prop-types';
import React from 'react';

import PartActionButton from './partActionButton';

export default function ProductNode({ data, selected = false }) {
  return (
    <div
      style={{
        padding: 10,
        border: `2px solid ${selected ? colorBorderItemSelected : colorBorderDividerDefault}`,
        borderRadius: 8,
        backgroundColor: colorBackgroundContainerContent,
        minWidth: 120,
      }}
    >
      <SpaceBetween size="xxs">
        <SpaceBetween size="xs" direction="horizontal">
          <Box><strong>{`${data.label} (${data.name})`}</strong></Box>
          <PartActionButton part={data} variant="inline-icon" />
        </SpaceBetween>
        <PPartStatusBadge status={data.status} />
        {!!data.notes && <div style={{ whiteSpace: 'pre-line' }}>{data.notes}</div>}
        {data.components?.length > 0 && (
          <div style={{ maxWidth: 300 }}>
            <SpaceBetween size="xxs" direction="horizontal">
              {data.components.map((component) => (
                <PPartRefBadge
                  key={`${component.projectDocId}/${component.pPartDocId}`}
                  projectDocId={component.projectDocId}
                  pPartDocId={component.pPartDocId}
                  quantity={component.quantity}
                />
              ))}
            </SpaceBetween>
          </div>
        )}
        {data.linkedParts?.length > 0 && (
          <div style={{ maxWidth: 300 }}>
            <SpaceBetween size="xxs" direction="horizontal">
              {data.linkedParts.map((row) => (
                <PPartRefBadge
                  key={`${row.projectDocId}/${row.pPartDocId}`}
                  projectDocId={row.projectDocId}
                  pPartDocId={row.pPartDocId}
                />
              ))}
            </SpaceBetween>
          </div>
        )}
      </SpaceBetween>

      {/* Connectors */}
      <Handle type="target" position={Position.Left} />
      <Handle type="source" position={Position.Right} />
    </div>
  );
}

ProductNode.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string.isRequired,
    status: PropTypes.string,
    name: PropTypes.string,
    notes: PropTypes.string,
    linkedParts: PropTypes.arrayOf(PropTypes.shape({
      projectDocId: PropTypes.string,
      pPartDocId: PropTypes.string,
    })),
    components: PropTypes.arrayOf(PropTypes.shape({
      projectDocId: PropTypes.string,
      pPartDocId: PropTypes.string,
      quantity: PropTypes.number,
    })),
  }).isRequired,
  selected: PropTypes.bool,
};
